import React, { useCallback, useState } from 'react';
import cx from 'classnames';

import { NotificationManager } from '@atlas/core';
import { parseWithdrawalQuery } from '@atlas/routing';
import { Button, DefaultPopup, Input, Label } from '@atlas/ui';

import PaymentListItem from 'src/components/ClientProfile/Payment/PaymentListItem';

import { showWithdrawalError, submitWithdrawal } from './withdrawalUtils';

const validateIBAN = value => {
  const maxLength = 34;
  const minLength = 16;
  if (!value) return { message: 'required' };

  if (value.length < minLength) {
    return { message: 'min_length', params: { ruleOption: minLength } };
  } else if (value.length > maxLength) {
    return { message: 'max_length', params: { ruleOption: maxLength } };
  } else {
    return null;
  }
};

const WithdrawalInterkassaEuroPopup = ({ data = {}, id }) => {
  const { paymentMethod, pmId, publicPaymentId, redirectUrl } = data;
  const [isActiveInput, setIsActiveInput] = useState(false);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [ibanValue, setIbanValue] = useState('');

  const { amount, currency } = parseWithdrawalQuery(redirectUrl);

  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  const changeAccountNumber = useCallback(event => {
    const value = event.target.value.replace(/[^a-zA-Z0-9]/g, '');

    const error = validateIBAN(value);

    setError(error);
    setIbanValue(value);
  }, []);

  const handleClickButton = useCallback(async () => {
    const requestData = {
      additionalParameters: {
        iban: ibanValue,
        publicPaymentId: publicPaymentId,
      },
      amount: amount,
      currency: currency,
      pmId: pmId,
    };

    setIsSubmitting(true);

    try {
      await submitWithdrawal({ amount, currency, paymentMethod, requestData });
    } catch {
      showWithdrawalError();
    } finally {
      setIsSubmitting(false);
      handleClose();
    }
  }, [ibanValue, publicPaymentId, amount, currency, pmId, paymentMethod, handleClose]);

  return (
    <DefaultPopup
      className={cx('payment-popup', 'full-height')}
      headerTitle="withdrawal"
      headerTitlePosition="left"
      onClose={handleClose}
    >
      <div className="payment-popup-content">
        <div className="popup-payment-method">
          <PaymentListItem amount={amount} payment={paymentMethod} showAmount />
        </div>

        <div className="payment-popup-block">
          <Input
            active={isActiveInput}
            className="popup-input"
            error={error}
            label="interkassa_euro_iban"
            maxLength={34}
            onBlur={() => setIsActiveInput(false)}
            onChange={changeAccountNumber}
            onFocus={() => setIsActiveInput(true)}
            value={ibanValue}
          />
          {error && (
            <div className="help-text-container">
              <Label message={error.message} params={error.params} />
            </div>
          )}
        </div>
      </div>

      <div className="popup__footer">
        <Button
          className="primary big block"
          disabled={!ibanValue || isSubmitting || error}
          error={error}
          label="withdrawal"
          loading={isSubmitting}
          onClick={handleClickButton}
        />
      </div>
    </DefaultPopup>
  );
};

export default WithdrawalInterkassaEuroPopup;
